import { useState } from 'react';

import { AdminOrganizer, getSharedBillingOrganizers } from '../../../api/services/Organizers';

export interface useOrganizersHook {
  organizers: Nullable<AdminOrganizer[]>;
  fetchOrganizers: (id: number) => void;
  clearOrganizers: () => void;
  isLoading: boolean;
}

export const useOrganizers = (): useOrganizersHook => {
  const [organizers, setOrganizers] = useState<Nullable<AdminOrganizer[]>>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  async function fetchOrganizers(id) {
    const abortController = new AbortController();

    setIsLoading(true);

    const response = await getSharedBillingOrganizers(id, abortController.signal);

    if (abortController.signal.aborted) {
      return;
    }
    if (response.type === 'success') {
      setOrganizers(response.data.adminOrganizers);
      setIsLoading(false);
    }
  }
  function clearOrganizers() {
    setOrganizers(null);
  }

  return { organizers, fetchOrganizers, clearOrganizers, isLoading };
};
